import template from './index.pug'

export default Vue.extend({
  name: 'transport-conditions-page',
  template: template(),
  created() {
    window.scrollTo(0, 0)
  }
})